import { render, staticRenderFns } from "./waitloading.vue?vue&type=template&id=33227798&scoped=true&"
import script from "./waitloading.vue?vue&type=script&lang=js&"
export * from "./waitloading.vue?vue&type=script&lang=js&"
import style0 from "./waitloading.vue?vue&type=style&index=0&id=33227798&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33227798",
  null
  
)

export default component.exports